<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <h1 data-test-id="ad-set-trace-title">Where is my Ad Set ?</h1>
        <div class="adset-trace_search-bar">
          <input
            autofocus
            v-on:keyup.enter="findAdSetTraceHandler"
            type="number"
            class="adset-trace_search-input text-input"
            v-model="adSetId"
            placeholder="Enter an Ad Set ID"
          />
          <button
            type="button"
            class="btn adset-trace_btn adset-trace_btn-primary"
            :disabled="loading"
            v-on:click="findAdSetTraceHandler"
          >
            Search
          </button>
        </div>
        <div
          v-if="info == null && !errored && !loading"
          class="adset-trace_centered"
        >
          <div>No Results to display yet.</div>
          <div>Type an Ad Set ID and click search to begin.</div>
        </div>
        <div v-if="info != null" class="adset-trace_info-data">
          <div class="adset-trace_info-summary">
            <div class="adset-trace_label">
              <h3>Ad Set: <a :href="`/campaigns/${info.campaignId}/adset/${info.id}/edit?switchToAdvertiserId=${info.advertiserId}`">{{ info.id }} - {{ info.name }}</a></h3>
            </div>
            <pulse-status
              :status="info.live"
              :show="info.live || !info.testMode"
              onMessage="Live"
              class="adset-trace_pulse-status"
            />
            <pulse-status
              :status="info.testMode"
              :show="info.testMode"
              onMessage="TestMode"
              class="adset-trace_pulse-status"
            />
            <div>
              Last Checked At:
              <span>{{
                new Date(info.checkedAt).toLocaleString("en-US")
              }}</span>
              &nbsp;
              <span
                v-on:click="refreshAdSetTraceHandler"
                class="adset-trace_btn glyphicon glyphicon-refresh"
              />
            </div>
          </div>
          <div class="adset-trace_info-summary-gutter">
            <h3>Campaign ID: <a :href="`/campaigns/${info.campaignId}?switchToAdvertiserId=${info.advertiserId}`">{{ info.campaignId }}</a></h3>
            <h3>Advertiser ID: {{ info.advertiserId }} - {{ info.advertiserName }}</h3>
          </div>
          <div class="adset-trace_check-table">
            <div
              v-for="check in info.checks"
              :key="check.name"
              class="adset-trace_check-row"
            >
              <div>{{ check.details }}</div>
                <span
                    v-if="check.pass"
                    class="glyphicon glyphicon-ok adset-trace_success-check"
                />
                <span
                    v-if="!check.pass && !check.testMode"
                    class="glyphicon glyphicon-remove adset-trace_fail-check"
                />
                <span
                    v-if="!check.pass && check.testMode"
                    class="glyphicon glyphicon-wrench adset-trace_test-mode"
                />
            </div>
          </div>
        </div>
        <div v-if="!loading && errored" class="adset-trace_centered">
          <b>Opps, Ad Set {{ adSetId }} can't be found</b>
        </div>
        <div class="adset-trace_centered" v-if="info == null && loading">
          <i class="fa fa-spinner fa-spin inner-loading"></i>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "AdSetTrace",
  props: {
    initialAdSetId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      adSetId: 0,
      info: null,
      loading: false,
      errored: false,
      errorMessage: "",
      currentAdSetId: 0,
    };
  },
  methods: {
    findAdSetTraceHandler: function () {
      if (!this.loading && this.adSetId != 0 && this.adSetId !== "")
        this.fetchAdSetTrace();
    },
    refreshAdSetTraceHandler: function () {
      this.fetchAdSetTrace(this.currentAdSetId);
    },
    updateRoute: function () {
      let updatedUrl = window.location.href;
      if (window.location.search !== "") {
        updatedUrl = window.location.href.replace(
          /adSetId=([\d\w]+)&*/g,
          `adSetId=${this.adSetId}`
        );
      } else {
        updatedUrl = window.location.href + `?adSetId=${this.adSetId}`;
      }

      window.history.pushState("", "Bankrate Portal", updatedUrl);
    },
    fetchAdSetTrace: function (adSetId = this.adSetId) {
      this.info = null;
      this.loading = true;
      this.errored = false;
      this.errorMessage = "";
      axios
        .get(`/api/tools/ad-set-trace/${adSetId}`)
        .then((response) => {
          this.currentAdSetId = this.adSetId;
          this.info = response.data;
          this.loading = false;
          this.updateRoute();
        })
        .catch((error) => {
          this.errored = true;
          this.loading = false;
          this.errorMessage = error.message;
          console.log(error);
        });
    },
  },

  created() {
    this.adSetId = this.initialAdSetId === 0 ? "" : this.initialAdSetId;
    if (this.initialAdSetId) {
      this.fetchAdSetTrace();
    }
  },
};
</script>

<style scoped>
.adset-trace_centered {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translateX(-50%);
  text-align: center;
}

.adset-trace_info-data {
  margin: 0 64px;
  margin-bottom: 32px;
}

.adset-trace_label {
  display: flex;
  justify-items: center;
}

.adset-trace_success-check {
  color: #00b532;
}

.adset-trace_fail-check {
  color: #f35252;
}

.adset-trace_test-mode {
  color: #4d64ff;
}

.adset-trace_info-summary {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  column-gap: 16px;
}

.adset-trace_info-summary-gutter {
  display: flex;
  column-gap: 16px;
}

.adset-trace_info-summary-gutter > h3 {
  margin-top: 0;
}

.adset-trace_pulse-status {
  flex-grow: 1;
}

.adset-trace_check-table .adset-trace_check-row:nth-child(even) {
  background: #ccc;
}

.adset-trace_check-table .adset-trace_check-row:nth-child(odd) {
  background: #f0f0f2;
}

.adset-trace_check-table .adset-trace_check-row:first-child {
  border-top: solid #80808082 1px;
}

.adset-trace_check-table .adset-trace_check-row:last-child {
  border-bottom: solid #80808082 1px;
}

.adset-trace_check-row {
  min-height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-right: solid #80808082 1px;
  border-left: solid #80808082 1px;
  padding: 0 16px;
}

.adset-trace_btn-primary {
  border: solid #4e63ff 1px;
}

.adset-trace_btn {
  cursor: pointer;
}

.adset-trace_btn:hover {
  transform: scale(1.015);
  animation: 500ms ease-in-out forwards;
}

.glyphicon-refresh:hover {
  transform: scale(1.15);
  animation: 500ms ease-in-out forwards;
}

.adset-trace_search-bar {
  display: flex;
}

.adset-trace_search-input {
  margin-right: 12px;
}
</style>
